import { FC, useState } from "react";
import BaseGrid from "../BaseGrid/BaseGrid";
import { BaseGridProperties } from "../BaseGrid/BaseGridProperties";
import { useBaseGrid } from "../BaseGrid/Hooks/useBaseGrid";
import CustomProgramAccessFilter from "./CustomProgramAccessFilter";
import { addAllOption } from "../../utilities/selectFunctions";
import BaseGridExternalDateFilter from "../BaseGrid/BaseGridCommonFilters/BaseGridExternalDateFilter";
import {
  addDays,
  areDatesEquals,
  FormattingDate,
  GettingDateWithoutTime,
} from "../../utilities/dateFunctions";
import { BaseTableColumn } from "../../dtos/base-table-column";
import { BaseTableInputType } from "../../dtos/base-table-input-type";
import { DataTypeEnums } from "../../dtos/data-type-enums";
import IconButton from "../TrueUI/Buttons/IconButton";
import LaunchIcon from "@mui/icons-material/Launch";
import { OptionsContextActionParameterProperties } from "../TrueUI/Tables/BaseTable2/TableProperties";
import { createBaseTableColumn } from "../BaseGrid/SupportFunctions/OLD_baseGridFunctions";

const mockColumns: BaseTableColumn[] = [
  {
    ...createBaseTableColumn(
      "ID",
      "Id",
      BaseTableInputType.TEXT,
      DataTypeEnums.STRING,
      ""
    ),
    isSortable: false,
  },
  {
    ...createBaseTableColumn(
      "Program",
      "Program",
      BaseTableInputType.TEXT,
      DataTypeEnums.STRING,
      ""
    ),
    isSortable: false,
  },
  {
    ...createBaseTableColumn(
      "Batch Type",
      "BatchType",
      BaseTableInputType.TEXT,
      DataTypeEnums.STRING,
      ""
    ),
    isSortable: false,
  },
  {
    ...createBaseTableColumn(
      "Description",
      "Description",
      BaseTableInputType.TEXT,
      DataTypeEnums.STRING,
      ""
    ),
    isSortable: false,
  },
  {
    ...createBaseTableColumn(
      "Status",
      "Status",
      BaseTableInputType.TEXT,
      DataTypeEnums.STRING,
      ""
    ),
    isSortable: false,
  },
  {
    ...createBaseTableColumn(
      "Scheduled Date",
      "ScheduledDate",
      BaseTableInputType.TEXT,
      DataTypeEnums.STRING,
      ""
    ),
    isSortable: false,
  },
  {
    ...createBaseTableColumn(
      "Recurrence",
      "Recurrence",
      BaseTableInputType.TEXT,
      DataTypeEnums.STRING,
      ""
    ),
    isSortable: false,
  },
];

const mockData = [
  [
    "123",
    "MTMIC",
    "Audit",
    "Send audit order forms to agency users",
    "Running",
    "4/1/2025",
    "M1",
  ],
  [
    "124",
    "MTMIC",
    "Cancel",
    "Process cancel notification letters for the month",
    "Scheduled",
    "4/1/2025",
    "M1",
  ],
  [
    "125",
    "LSIF",
    "Policy",
    "Print policy docs for policies bound on previous day",
    "Rescheduled",
    "4/3/2025",
    "",
  ],
];

type FormBoxTableProps = {};

const TABLE_NAME = "formbox-table";

const FormBoxTable: FC<FormBoxTableProps> = () => {
  const defaultFromDate = new Date();
  const defaultToDate = addDays(defaultFromDate, 7);
  const formatDate = (date: Date) => FormattingDate(date, "YYYY-MM-DD");

  const [dateFrom, setDateFrom] = useState<string>(formatDate(defaultFromDate));
  const [dateTo, setDateTo] = useState<string>(formatDate(defaultToDate));

  const actionsForRows = (
    actionOptions: OptionsContextActionParameterProperties<any>
  ) => (
    <IconButton
      aria-label="expand row"
      onClick={() => console.log("next PR", actionOptions)}
    >
      <LaunchIcon fontSize="small" />
    </IconButton>
  );

  const tableConfig: BaseGridProperties = {
    name: TABLE_NAME,
    columnsAndData: {
      columns: mockColumns,
      data: mockData,
    },
    useManuallyReloadParameters: true,
    columnOptions: [
      { fieldName: "Id", width: 3 },
      { fieldName: "Program", width: 15 },
      { fieldName: "BatchType", width: 15 },
      { fieldName: "Description", width: 43 },
      { fieldName: "Status", width: 8 },
      { fieldName: "ScheduledDate", width: 8 },
      { fieldName: "Recurrence", width: 6 },
      { fieldName: "OPTIONS", width: 2 },
    ],
    toolbarOptions: {
      showAddButton: false,
      showEditButton: false,
      showExcelButton: true,
      showPDFButton: true,
      showImportButton: false,
      showSaveButton: false,
      showSortFilter: false,
    },
    filterOptions: [
      (options) =>
        CustomProgramAccessFilter({
          id: "program-filter",
          columnNames: ["ProgramAccessHidden"],
          labelText: "Program:",
          optionsOverride: addAllOption([
            { displayName: "Program 1", stringValue: "1" },
            { displayName: "Program 2", stringValue: "2" },
          ]),
          options,
          onChange: () => {},
        }),
      (options) =>
        BaseGridExternalDateFilter({
          options,
          label: "From:",
          inputWidth: "210px",
          defaultValue: GettingDateWithoutTime(dateFrom),
          isStaticFilter: true,
          id: "fromDate",
          onChangeRawValue: (value) => {
            const isEqual = areDatesEquals(value, new Date(dateFrom));
            if (isEqual === false) {
              setDateFrom(formatDate(value));
            }
          },
          triggerSearchOnBlur: true,
        }),
      (options) =>
        BaseGridExternalDateFilter({
          options,
          label: "To:",
          inputWidth: "210px",
          defaultValue: GettingDateWithoutTime(dateTo),
          isStaticFilter: true,
          id: "toDate",
          onChangeRawValue: (value) => {
            const isEqual = areDatesEquals(value, new Date(dateTo));
            if (isEqual === false) {
              setDateTo(formatDate(value));
            }
          },
          triggerSearchOnBlur: true,
        }),
    ],
    advancedOptions: {
      optionsColumnConfiguration: {
        isHidden: false,
        optionType: "component",
      },
      optionsContextActions: {
        contextComponent: actionsForRows,
      },
    },
  };

  useBaseGrid(tableConfig);

  return (
    <div style={{ width: "100%", height: "75vh" }}>
      <BaseGrid name={TABLE_NAME} />
    </div>
  );
};
export default FormBoxTable;
